import {FC, MutableRefObject, useEffect, useMemo} from 'react'
import {useDispatch} from 'react-redux'
import {useParams} from 'react-router'
import {GetChatRequest, setChatRequest} from 'entities/messages'
import {useUser} from 'entities/user'
import {WarningModalProvider} from 'features/warningModal/context'
import {scrollToTop} from 'shared/lib/scroll-to'
import {UserStatus} from 'shared/types'
import styles from './styles.module.scss'
import {Profile} from './ui/profile'

const ActiveProfile: FC<{wrapperRef: MutableRefObject<HTMLDivElement | null>}> = ({wrapperRef}) => {
  const dispatch = useDispatch()
  const {id} = useParams()

  useEffect(() => {
    scrollToTop(wrapperRef)

    if (!id) return

    GetChatRequest(id)
      .then(({data}) => dispatch(setChatRequest(data)))
      .catch(console.error)
  }, [id])

  return (
    <Profile wrapperRef={wrapperRef} />
  )
}

const DeactivatedProfile: FC<{wrapperRef: MutableRefObject<HTMLDivElement | null>}> = ({wrapperRef}) => {
  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        <Profile className={styles.profile} wrapperRef={wrapperRef} />
      </div>
    </div>
  )
}


export const ProfilePage: FC<{wrapperRef: MutableRefObject<HTMLDivElement | null>}> = ({wrapperRef}) => {
  const {status} = useUser()

  const isActive = useMemo(() => status === UserStatus.ACTIVE, [status])

  return (
    <WarningModalProvider>
      {isActive ? <ActiveProfile wrapperRef={wrapperRef} /> : <DeactivatedProfile wrapperRef={wrapperRef} />}
    </WarningModalProvider>
  )
}
